"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.inputOutputComparator = inputOutputComparator;
exports.tradeComparator = tradeComparator;
const tiny_invariant_1 = __importDefault(require("tiny-invariant"));
// comparator function that allows sorting trades by their output amounts, in decreasing order, and then input amounts
// in increasing order. i.e. the best trades have the most outputs for the least inputs and are sorted first
function inputOutputComparator(a, b) {
    // must have same input and output token for comparison
    (0, tiny_invariant_1.default)(a.inputAmount.currency.equals(b.inputAmount.currency), 'INPUT_CURRENCY');
    (0, tiny_invariant_1.default)(a.outputAmount.currency.equals(b.outputAmount.currency), 'OUTPUT_CURRENCY');
    if (a.outputAmount.equalTo(b.outputAmount)) {
        if (a.inputAmount.equalTo(b.inputAmount))
            return 0;
        // trade A requires less input than trade B, so A should come first
        if (a.inputAmount.lessThan(b.inputAmount))
            return -1;
        else
            return 1;
    }
    else {
        // tradeA has less output than trade B, so should come second
        if (a.outputAmount.lessThan(b.outputAmount))
            return 1;
        else
            return -1;
    }
}
function tradeComparator(a, b) {
    const ioComp = inputOutputComparator(a, b);
    if (ioComp !== 0)
        return ioComp;
    // consider lowest slippage next, since these are less likely to fail
    if (a.priceImpact.lessThan(b.priceImpact))
        return -1;
    else if (a.priceImpact.greaterThan(b.priceImpact))
        return 1;
    return a.route.routePath.length - b.route.routePath.length;
}
